'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const ValuePropositionSection = () => {
  const benefits = [
    {
      icon: 'ChartBarIcon',
      title: 'Measurable ROI',
      description: 'Track tangible business outcomes with clear metrics and KPIs from day one of your transformation journey.',
    },
    {
      icon: 'UserGroupIcon',
      title: 'Human-Centered Approach',
      description: 'Address the leadership and cultural challenges that determine AI success, not just technology implementation.',
    },
    {
      icon: 'LightBulbIcon',
      title: 'Proven Methodology',
      description: 'Leverage frameworks tested across 200+ enterprise transformations with an 85% success rate.',
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Risk Mitigation',
      description: 'Reduce transformation risk through structured change management and expert implementation support.',
    },
  ];

  return (
    <section id="value-proposition" className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-primary mb-6">
              Why Enterprise Leaders Choose Us
            </h2>
            <p className="text-xl text-muted-foreground font-body max-w-3xl mx-auto">
              We bridge the gap between AI investment and organizational success through proven change management frameworks.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {benefits?.map((benefit, index) => (
              <div
                key={index}
                className="bg-card rounded-xl p-8 shadow-subtle hover:shadow-strong transition-all duration-300 border border-border hover:border-primary/30"
              >
                <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-6">
                  <Icon name={benefit?.icon} size={28} variant="solid" className="text-primary" />
                </div>
                <h3 className="text-2xl font-bold font-headline text-primary mb-4">
                  {benefit?.title}
                </h3>
                <p className="text-foreground font-body leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-2xl p-8 lg:p-12 border border-primary/10">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-bold font-headline text-primary mb-4">
                  What to Expect in Your Discovery Call
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success flex-shrink-0 mt-0.5" />
                    <span className="text-foreground font-body">Comprehensive organizational assessment and AI readiness evaluation</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success flex-shrink-0 mt-0.5" />
                    <span className="text-foreground font-body">Tailored transformation roadmap aligned with your business objectives</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success flex-shrink-0 mt-0.5" />
                    <span className="text-foreground font-body">Clear implementation timeline with milestone planning</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-success flex-shrink-0 mt-0.5" />
                    <span className="text-foreground font-body">ROI projection and success metrics framework</span>
                  </li>
                </ul>
              </div>
              <div className="flex-shrink-0">
                <div className="w-48 h-48 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                  <Icon name="CalendarDaysIcon" size={80} variant="solid" className="text-white" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;